import { useLocalPodcast } from './podcast-provider';

export const PodcastAuthor = () => {
  const { podcast }= useLocalPodcast();


  return (
    <span>{podcast?.author}</span>
  );
}